import { useEffect, useState } from 'react';
import { getLogs, downloadLog } from '../../services/server/logsViewerService.js';

export const useLogs = () => {
    // data
    const [logs, setLogs] = useState([]);
    // búsqueda
    const [searchTerm, setSearchTerm] = useState('');
    // paginación
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    // feedback
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    // loading
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadLogs();
    }, []);

    // Cargar logs
    const loadLogs = async () => {
        try {
            setLoading(true);
            const data = await getLogs();
            // ordenar por fecha descendente (nombre del archivo)
            const sorted = [...data].sort((a, b) => b.localeCompare(a));
            setLogs(sorted);
        } catch (err) {
            setError('Error al cargar logs.');
        } finally {
            setLoading(false);
        }
    };

    // Descargar archivo
    const handleDownload = async (filename) => {
        try {
            setLoading(true);
            const blob = await downloadLog(filename);

            // Crear URL temporal
            const url = window.URL.createObjectURL(blob);

            // Crear link y disparar descarga
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            // Limpieza
            link.remove();
            window.URL.revokeObjectURL(url);

            setSuccess(`Descargado: ${filename}`);
        } catch (err) {
            setError('Error al descargar archivo');
        } finally {
            setLoading(false);
        }
    };

    return {
        logs,
        searchTerm,
        setSearchTerm,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        handleDownload,
        error,
        setError,
        success,
        setSuccess,
        loading
    };
};